module.exports = __webpack_public_path__ + "img/Adams.351cf6d3.png";